import { render, staticRenderFns } from "./AddShiftManagementDialog.vue?vue&type=template&id=58e4191a&scoped=true"
import script from "./AddShiftManagementDialog.vue?vue&type=script&lang=js"
export * from "./AddShiftManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./AddShiftManagementDialog.vue?vue&type=style&index=0&id=58e4191a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e4191a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e4191a')) {
      api.createRecord('58e4191a', component.options)
    } else {
      api.reload('58e4191a', component.options)
    }
    module.hot.accept("./AddShiftManagementDialog.vue?vue&type=template&id=58e4191a&scoped=true", function () {
      api.rerender('58e4191a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance-v2/dialog/AddShiftManagementDialog.vue"
export default component.exports